define('lq/events/actions/readOutlookMessage',[
    'underscore',
    'globalize',
    'lq/events/actions/eventAction',
    'lq/constants'
], function(_, globalize, EventAction, constants) {
    'use strict';

    // reference: https://dev.office.com/reference/add-ins/outlook/1.5/Office

    var initialized = false;
    var initializing = false;
    var afterInitialization = [];
    
    function ReadOutlookMessage(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ReadOutlookMessage, EventAction);

    ReadOutlookMessage.typeName = 'ReadOutlookMessage';

    // unable to batch for now, because requesting a token is async
    ReadOutlookMessage.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    ReadOutlookMessage.prototype.execute = function (continuation) {
        var self = this;

        if (initialized)
            self.startReadingMessage(continuation);
        else {
            afterInitialization.push(self.startReadingMessage.bind(self, continuation));

            if (!initializing) {
                initializing = true;

                require([
                    'https://unpkg.com/@azure/msal-browser@4.15.0/lib/msal-browser.js',
                    'https://appsforoffice.microsoft.com/lib/1/hosted/Office.js',
                ], function (msal) {
                    self.msal = msal;

                    Office.onReady(function () {
                        initialized = true;

                        _.each(afterInitialization,
                            function (afterInitialization) {
                                afterInitialization();
                            });
                    })
                });
            }
        }
    };

    ReadOutlookMessage.prototype.doReadMessage = function(userAccount, continuation) {
        var self = this;

        var ewsItemId = Office.context.mailbox.item.itemId;

        var itemId = Office.context.mailbox.convertToRestId(
            ewsItemId,
            Office.MailboxEnums.RestVersion.v2_0);

        self.piping.dispatcher.dispatch('Outlook/FetchMessage',
                {
                    actionId: self.piping.actionId,
                    commandId: self.eventData.commandId,
                    accessToken: userAccount.accessToken,
                    itemId: itemId
                })
            .then(function (result) {
                if (self.eventData.messageEntityId)
                    self.piping.parameters.locals.setValue(self.eventData.messageEntityId, result.id);

                self.readParameters(continuation);
            });
    };

    ReadOutlookMessage.prototype.startReadingMessage = function (continuation) {
        var self = this;

        if (!self.eventData.storeMessage) {
            self.readParameters(continuation);
            return;
        }

        self.msal.createNestablePublicClientApplication({
            auth: {
                clientId: self.eventData.officeAddinClientId,
                authority: "https://login.microsoftonline.com/" + (self.eventData.officeAddinTenant || 'common')
            },
        })
            .then(function (pca) {
                var tokenRequest = {
                    scopes: ["Mail.Read", "User.Read", "openid", "profile", "email"],
                };

                pca.acquireTokenSilent(tokenRequest)
                    .then(function (userAccount) {
                        self.doReadMessage(userAccount, continuation);
                    })
                    .catch(function (error) {
                        console.log('Failed to get Office token silently: ' + error);

                        pca.acquireTokenPopup(tokenRequest)
                            .then(function (userAccount) {
                                self.doReadMessage(userAccount, continuation);
                            })
                            .catch(function (error) {
                                throw new Error('Failed to get Office token: ' + error);
                            })
                    })
            })
            .catch(function (error) {
                throw new Error('Failed to get Office token: ' + error);
            })
    };

    ReadOutlookMessage.prototype.readParameters = function (continuation) {
        var item = Office.context.mailbox.item;
        
        if (this.eventData.subject)
            this.piping.parameters.locals.setValue(this.eventData.subject, item.subject);

        if (this.eventData.sender)
            this.piping.parameters.locals.setValue(this.eventData.sender, this.printEmailAddress(item.sender));

        if (this.eventData.to)
            this.piping.parameters.locals.setValue(this.eventData.to, this.printEmailAddresses(item.to));

        if (this.eventData.cc)
            this.piping.parameters.locals.setValue(this.eventData.cc, this.printEmailAddresses(item.cc));

        if (this.eventData.bcc)
            this.piping.parameters.locals.setValue(this.eventData.bcc, this.printEmailAddresses(item.bcc));

        if (this.eventData.hasAttachments)
            this.piping.parameters.locals.setValue(this.eventData.hasAttachments, item.attachments.length > 0);

        if (this.eventData.dateTimeCreated) {
            var theDate = globalize.format(item.dateTimeCreated, constants.licquidDateFormat);
            this.piping.parameters.locals.setValue(this.eventData.dateTimeCreated, theDate);
        }

        if (this.eventData.body) {
            var self = this;
            item.body.getAsync('text', function callback(result) {
                if (result.status !== 'succeeded')
                    throw new Error('Unable to get the body of the mail from Outlook.');

                self.piping.parameters.locals.setValue(self.eventData.body, result.value);
                continuation();
            });
        } else {
            continuation();
        }
    };

    ReadOutlookMessage.prototype.printEmailAddresses = function (addresses) {
        var printedAddresses = _.map(addresses, this.printEmailAddress.bind(this));
        return printedAddresses.join(', ');
    };

    ReadOutlookMessage.prototype.printEmailAddress = function (address) {
        if (!address) return null;

        if (this.eventData.displayMode === 'emailAddress')
            return address.emailAddress;

        if (this.eventData.displayMode === 'displayName')
            return address.displayName;

        return address.displayName + ' <' + address.emailAddress  + '>';
    };

    return ReadOutlookMessage;
});
